/**
 * Kod wygenerowany automatycznie przez automatyczne narz�dzie (problemy zg�asza� do Tomasza Grze�kiewicza)
 * nie zmieniaj tego pliku, wszystkie zmiany zostan� nadpisane automatycznie
 */
import {Api} from "../index";
import {ReactivityValidator} from "../../utils/ReactivityValidator"

export const DataImport = {

	postExample (context, onSuccess, onError, options) {
		Api.post(context,
			"/data-import/example"
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postFinancialTables (context, projectId, file, onSuccess, onError, options) {
		Api.post(context,
			"/data-import/financial-tables"
			+ "?projectId=" + projectId
			+ "&file=" + file
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

};
